import React, {useState} from 'react';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import { Icon, makeStyles } from '@material-ui/core';
import CollapseItem from './CollapseItem';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    listItems: {
        color: 'white',
        textAlign: "left",
        "&:hover": {
            color: 'white'
        }
    },
    fontsize : {
        [theme.breakpoints.up('xs')]: {
            fontSize: '110%',
            // fontWeight: 'bold',
            fontFamily: 'Ubuntu',
            borderLeft: '3px solid rgba(255, 198, 0)',
            paddingLeft: "5%"
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '110%',
            // fontWeight: 'bold',
            fontFamily: 'Ubuntu',
            borderLeft: '3px solid rgba(255, 198, 0)',
            paddingLeft: "5%"
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '110%',
            // fontWeight: 'bold',
            fontFamily: 'Ubuntu',
            borderLeft: '3px solid rgba(255, 198, 0)',
            paddingLeft: "5%"
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '110%',
            // fontWeight: 'bold',
            fontFamily: 'Ubuntu',
            borderLeft: '3px solid rgba(255, 198, 0)',
            paddingLeft: "5%"
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '100%',
            // fontWeight: 'bold',
            fontFamily: 'Ubuntu',
            borderLeft: '3px solid rgba(255, 198, 0)',
            paddingLeft: "5%"
        },

    },
    listItemsactive: {
        color: 'white',
        textAlign: "left",
        "&:hover": {
            color: 'white'
        }
    },
    listItemsdesactive: {
        color: 'white',
        textAlign: "left",
        "&:hover": {
            color: 'white'
        }
    },
    listSubItemsactive: {
        color: 'white',
        "&:hover": {
            color: 'white'
        }
    },
    listSubItemsactivebackground: {
        paddingLeft: theme.spacing(4),
        backgroundColor: "#fcba03",
        "&:hover": {
            backgroundColor: "#fcba03"
        }
    },
    listSubItemsdesactivebackground: {
        paddingLeft: theme.spacing(4),
        backgroundColor: "#009aa8",
        "&:hover": {
            backgroundColor: "#009aa8"
        }
    },
    menuactive: {
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: theme.palette.primary.main
        }
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    menudesactive: {
        backgroundColor: '#0097a0',
        "&:hover": {
            backgroundColor: '#0097a0'
        }
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: '8px',
            height: '15px'
        },
        [theme.breakpoints.up('sm')]: {
            width: '8px',
            height: '15px'
        },
        [theme.breakpoints.up('md')]: {
            width: '8px',
            height: '15px'
        },
        [theme.breakpoints.up('lg')]: {
            width: '8px',
            height: '15px'
        },
        [theme.breakpoints.up('xl')]: {
            width: '8px',
            height: '15px'
        },
        // width: '70%',
        // height: '100%'
      },
    icon: {
        [theme.breakpoints.up('xs')]: {
           minWidth: '15%'
        },
        [theme.breakpoints.up('sm')]: {
            width: `15%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `15%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `15%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `15%`,
        },
      // height: '15%'
    },
}));


const MenuItems = props => {
    const { sendData , items, menuselectedsimple, menuCollapseSelected, submenuCollapseSelected, menuselectedcollapse } = props

    const [ open, setOpen ] = useState(false)
    const [ openSub, setOpenSub ] = useState(false)

    const classes = useStyles()
    return (
        <div>
            <List>
                {
                    items.map((item) => {
                        const { icon, text, route, type, state } = item
                        if(state){

                            if (type === 'simple') {
                                return <ListItem key={text} button = { (isMobile) ? false : true } selected = {false} onClick={() => sendData(route, text)} className = {(text === menuselectedsimple) ? classes.menuactive : classes.menudesactive}>

                                            <ListItemText primary={<Typography
                                                                        component="span"
                                                                        variant="body2"
                                                                        className={classes.fontsize}
                                                                    >
                                                                        { text }
                                                                    </Typography> } className = {(text === menuselectedsimple) ? classes.listItemsactive : classes.listItems}/>

                                        </ListItem>
                            } else if ( type ==='collapse') {
                                const { subItems } = item
                                if (item.svg) {
                                    return  <CollapseItem  svg = {item.svg } svgRoute = {item.svgRoute} key={text} icon = { icon } text ={text} state = {state}
                                    subItems = { subItems } onSendData = { (r, t) => sendData(r, t)} classes = { classes } menuselectedsimple = { menuselectedsimple } menuCollapseSelected = { menuCollapseSelected} menuselectedcollapse = { menuselectedcollapse } submenuCollapseSelected = { (r, t, tf) => submenuCollapseSelected(r, t, tf)} 
                                    open = {open} setOpen = { (s) => setOpen(s) }
                                    openSub = {openSub} setOpenSub = { (s) => setOpenSub(s) }
                                    />
                                } else {
                                    return <CollapseItem key={text} icon = { icon } text ={text} state = {state}
                                            subItems = { subItems } onSendData = { (r, t) => sendData(r, t)} classes = { classes } menuselectedsimple = { menuselectedsimple } menuCollapseSelected = { menuCollapseSelected} menuselectedcollapse = { menuselectedcollapse } submenuCollapseSelected = { (r, t, tf) => submenuCollapseSelected(r, t, tf)} open = {open} setOpen = { (s) => setOpen(s) }/>
                                }

                            } else { return null }

                        } else { return null }
                    })
                }
            </List>
            <Divider />
            <List>
                {
                    items.map((item) => {
                        const { icon, text, route, type } = item
                        if (type === 'secondary') {
                            return <ListItem button key={text} onClick={() => sendData(route)} className = {(text === menuselectedsimple) ? classes.menuactive : classes.menudesactive}>
                                        {
                                            item.svg ?
                                            <div className={classes.icon} >
                                                <img src={item.svgRoute} alt="Logo" className={classes.logo}  />
                                            </div>
                                            :
                                            <ListItemIcon>
                                            <Icon>{ icon }</Icon>
                                            </ListItemIcon>
                                        }
                                        <ListItemText primary={<Typography
                                                                    component="span"
                                                                    variant="body2"
                                                                    className={classes.fontsize}
                                                                >
                                                                    { text }
                                                                </Typography>} className = { classes.listItems }/>
                                    </ListItem>
                        } else { return null }
                    })
                }
            </List>
        </div>
    );
};

MenuItems.propTypes = {
    sendData: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
};

export default MenuItems;
